<template>
  <div class="container">
    <li class="item"
      @click='onClickItem()'
      v-bind:class="{'active': item && currentItem && item.id === currentItem.id, 'normal' : item && currentItem && item.id !== currentItem.id}">				
     <label class="title">{{getTitle}}</label>
    </li>
  </div>
</template>

<script>
export default {
  name: 'TopItem',
  props: {
    item: null,
    currentItem: null,    
  },
  computed: {
    getTitle() {
      return this.item ? this.item.title : ''
    }
  },
  methods: {
    onClickItem() {
			this.$emit('clickItem', this.item)
		}
  }
}
</script>

<style scoped lang='scss'>
.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}
.item {
  font-size: 14px;
  color: #4E545D;
  border-bottom: 2px solid transparent;
  position: relative;
  flex-basis: 100px;
  text-align: center;
  height: 42px;
  padding: 0px;
  line-height: 42px;   
  background-color: lightpink; 
}
.title {
  font-size: 14px;
  color: #404245;
}
.active {
  border-bottom-color: $primaryColor;  
}
.normal {
  border-bottom-color: transparent;
}
</style>





// WEBPACK FOOTER //
// src/components/common/TopItem.vue